import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { openModal } from "../../data/slices/modals";

function PointedSumPopup() {
  const dispatch = useDispatch();
  const { id: projectId } = useParams();
  const prevProjectIdRef = useRef(null);

  useEffect(() => {
    const storedProjectId = sessionStorage.getItem("lastOpenedProjectId");

    if (projectId && storedProjectId !== projectId) {
      dispatch(openModal("project-ready-actions-modal", { projectId }));
      sessionStorage.setItem("lastOpenedProjectId", projectId);
      prevProjectIdRef.current = projectId;
    }
  }, [dispatch, projectId]);

  return null;
}

export default PointedSumPopup;
